import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Introduction to agents concept" visualizer="bottom-right">
      <div className="slide">
        <h1>Wat zijn Agents</h1>
        <p>Doorgaans wordt de term gebruikt voor autonome systemen die:</p>
        <ul>
          <li>Zelfstandig beslissingen kunnen nemen</li>
          <li>Een doel nastreven zonder directe menselijke input</li>
          <li>Kunnen leren van hun interacties</li>
        </ul>
      </div>
    </Slide>
  );
};
